<template>
    <span  @click="showDialog = true" class="cursor-pointer">
        <vs-chip v-if="!isFromFolder" class="mt-2">
            <vs-avatar></vs-avatar>
            {{(supplier.id === null) ? 'Asignar Proveedor' : supplier.tradename}}
        </vs-chip>
        
        <vs-button size="small" color="warning" type="line" v-else>
            Asignar proveedor
        </vs-button>

        <vs-popup :active.sync="showDialog" title="Asignar proveedor">
            <autocomplete
                ref="autocomplete"
                :source="supplierEndpoint"
                input-class="form-control"
                placeholder="Seleccionar un proveedor"
                :request-headers="authHeaders"
                :results-display="formattedDisplay"
                @selected="selectedSupplier">
            </autocomplete>
            <br>
            <!-- SUPPLIER RESTRICTION NOTIF -->
            <div v-if="supplier.id != null" class="vx-row">
                <div class="vx-col w-full">
                    <SupplierRestrictedData :source="supplier" />
                </div>
            </div>
            <supplier-details
                    ref="suppler_detail_component"
                    :supplier_id="supplier.id"
                    v-if="supplier.id !== null"></supplier-details>

            <div class="mt-6 flex gap-2 justify-start flex-row-reverse">
                <vs-button color="dark" @click="showDialog = false">Cerrar</vs-button>
                <vs-button @click="updateSupplier()">Guardar</vs-button>
            </div>
        </vs-popup>
    </span>
</template>

<script>
    import Autocomplete from 'vuejs-auto-complete';
    import * as moment from 'moment';
    import SupplierDetails from "../../views/admin/projects/process-flow/SupplierDetails";
    import { mapState } from 'vuex';

    export default {
        name: "ProjectSupplierSelector",
        components: {SupplierDetails, Autocomplete},
        props: {
            project_id: {
                type: Number,
                required: true
            },
            supplier: {
                type: Object,
                default: () => ({})
            },
            isFromFolder: {
                type: Boolean,
                default: () => false
            }
        },
        data: () => ({
            showDialog: false,
            supplier_id_selected: null,
            supplierEndpoint: `${process.env.VUE_APP_API_DOMAIN}/api/suppliers/search?search=`,
        }),
        computed: {
            ...mapState('auth', ['user']),
            authHeaders() { return {  "Authorization": "Bearer " + this.user.access_token } },
        },
        methods: {
            selectedSupplier(supplier) {
                this.supplier_id_selected = supplier.value;
            },
            formattedDisplay(result) {
                return result.tradename;
            },
            async updateSupplier() {
                try {
                    let res = await axios.post(`/api/project/${this.project_id}/assign_supplier`, {
                        supplier_id: this.supplier_id_selected
                    })
                    this.$emit("update:supplier", res.data.supplier)
                    swal("Ok!", "El proveedor se ha asignado correctamente", "success");
                    this.$refs.suppler_detail_component.update();

                    this.showDialog = false;
                } catch(e) {
                    swal("Upss!", "Hubo un error al asignar proveedor", "error");
                }
            }
        }
    }
</script>

<style scoped>
.md-avatar {
    margin-left: -12px;
    margin-top: -3px;
}
</style>
